<template>
    <div class="account-item">
        <div class="account-link">
            <div class="account-icon">
                <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.30423 1.38678C8.11037 1.1407 9.17762 1 10.3229 1C11.4683 1 12.5355 1.1407 13.3417 1.38678C13.7408 1.50862 14.1168 1.66852 14.4082 1.87885C14.6905 2.08266 15 2.41607 15 2.88172V8.90323C15 9.37825 14.6569 9.70536 14.3906 9.89036C14.1007 10.0918 13.7258 10.2515 13.3233 10.3764C12.6853 10.5743 11.8843 10.7132 11.0116 10.7638V13.0803C11.0116 13.5454 10.7081 13.8831 10.422 14.0937C10.1284 14.3099 9.74876 14.4748 9.34476 14.6006C8.52929 14.8547 7.44956 15 6.2907 15C5.13192 15 4.0522 14.8548 3.23671 14.6009C2.83269 14.4751 2.45298 14.3102 2.15938 14.0939C1.87313 13.8831 1.56977 13.5453 1.56977 13.0803V10.1075C1.56977 9.63864 1.88449 9.30491 2.16807 9.10245C2.21486 9.06904 2.26382 9.03691 2.3147 9.006C2.08097 8.9191 1.86764 8.82047 1.68583 8.70894C1.41087 8.54027 1 8.21202 1 7.69893V4.68817C1 4.17809 1.38528 3.8425 1.68072 3.65795C2.00166 3.45747 2.41792 3.30363 2.86645 3.18514C3.62268 2.98537 4.58981 2.85548 5.64785 2.81781C5.67452 2.38543 5.96844 2.07321 6.2377 1.87885C6.52909 1.66852 6.90507 1.50862 7.30423 1.38678ZM5.64588 4.17382C4.70257 4.21085 3.87663 4.32733 3.26888 4.48787C3.01756 4.55426 2.82201 4.62343 2.67801 4.68817C2.82201 4.75292 3.01756 4.82209 3.26888 4.88848C3.87663 5.04902 4.70257 5.16549 5.64588 5.20252V4.17382ZM5.64588 6.55847C4.58862 6.5207 3.62221 6.39085 2.86645 6.1912C2.72904 6.1549 2.59466 6.11529 2.46512 6.07203V7.56043C2.4741 7.56639 2.48427 7.57289 2.49573 7.57992C2.6412 7.66916 2.89775 7.77727 3.27477 7.88003C3.88327 8.04589 4.70775 8.17162 5.64588 8.21201V6.55847ZM7.111 8.24982V7.31907C7.16015 7.33544 7.20982 7.35127 7.25991 7.36657C8.08208 7.61782 9.16955 7.77419 10.3229 7.77419C11.4764 7.77419 12.5446 7.61781 13.3484 7.36461C13.4114 7.34479 13.4736 7.32409 13.5349 7.30248V8.78965C13.5278 8.79495 13.5198 8.80078 13.5107 8.80711C13.3932 8.88869 13.1796 8.9919 12.8573 9.09187C12.3212 9.25817 11.5866 9.38427 10.7556 9.41992C10.6524 9.29162 10.5302 9.18589 10.4133 9.10245C10.1198 8.89286 9.74089 8.73345 9.33826 8.61189C8.72107 8.42556 7.95175 8.29968 7.111 8.24982ZM13.5803 8.74957C13.5806 8.74958 13.5789 8.75197 13.5742 8.75667C13.5776 8.7519 13.58 8.74955 13.5803 8.74957ZM13.5777 5.74487C13.578 5.74489 13.5764 5.7471 13.5721 5.75147C13.5753 5.74704 13.5774 5.74485 13.5777 5.74487ZM2.4042 7.5124C2.40469 7.51236 2.40827 7.51553 2.41348 7.52205C2.40631 7.5157 2.40371 7.51244 2.4042 7.5124ZM2.41659 4.5324C2.41693 4.53237 2.41949 4.53476 2.42327 4.53965C2.41815 4.53487 2.41626 4.53243 2.41659 4.5324ZM7.111 5.83164V4.31394C7.17462 4.3359 7.23911 4.35679 7.30423 4.37667C8.11037 4.62274 9.17762 4.76344 10.3229 4.76344C11.4683 4.76344 12.5355 4.62274 13.3417 4.37667C13.4068 4.35679 13.4713 4.3359 13.5349 4.31394V5.78338C13.5282 5.78854 13.5205 5.79421 13.5118 5.80038C13.399 5.88036 13.1918 5.98267 12.876 6.08212C12.2524 6.27857 11.3483 6.41935 10.3229 6.41935C9.29754 6.41935 8.36889 6.27856 7.71963 6.08016C7.44072 5.99492 7.24 5.90708 7.111 5.83164ZM13.4024 2.88172C13.2855 2.94633 13.1148 3.01918 12.8824 3.09011C12.2608 3.27984 11.3558 3.4086 10.3229 3.4086C9.29005 3.4086 8.38505 3.27984 7.76349 3.09011C7.53113 3.01918 7.36036 2.94633 7.24349 2.88172C7.36036 2.81711 7.53113 2.74426 7.76349 2.67333C8.38505 2.4836 9.29005 2.35484 10.3229 2.35484C11.3558 2.35484 12.2608 2.4836 12.8824 2.67333C13.1148 2.74426 13.2855 2.81711 13.4024 2.88172ZM6.2907 9.58064C5.24488 9.58064 4.32809 9.70955 3.69785 9.89983C3.46424 9.97036 3.29167 10.0429 3.17278 10.1075C3.29167 10.1722 3.46424 10.2447 3.69785 10.3152C4.32809 10.5055 5.24488 10.6344 6.2907 10.6344C7.33652 10.6344 8.2533 10.5055 8.88355 10.3152C9.11716 10.2447 9.28972 10.1722 9.40861 10.1075C9.28972 10.0429 9.11716 9.97036 8.88355 9.89983C8.2533 9.70955 7.33652 9.58064 6.2907 9.58064ZM9.54651 11.536C9.47804 11.5596 9.40851 11.582 9.33826 11.6032C8.525 11.8487 7.4476 11.9892 6.2907 11.9892C5.1338 11.9892 4.0564 11.8487 3.24313 11.6032C3.17289 11.582 3.10336 11.5596 3.03488 11.536V13.0046C3.04419 13.0127 3.05638 13.0225 3.07212 13.0341C3.18216 13.1152 3.38654 13.2179 3.70428 13.3169C4.33229 13.5124 5.24675 13.6452 6.2907 13.6452C7.33456 13.6452 8.24901 13.5123 8.87705 13.3167C9.1948 13.2177 9.39923 13.1149 9.50932 13.0338C9.52503 13.0223 9.53721 13.0125 9.54651 13.0044V11.536Z"
                        fill="black"
                    />
                </svg>
            </div>

            <div class="account-name text-h3">
                {{ accountData.name }}
            </div>
        </div>

        <div v-if="showBalance" class="account-balance text-h3 text-grey">
            {{ accountData.balance }}
        </div>

        <template v-if="editable">
            <div class="edit-icon" @click="editAccount">
                <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M13.4742 2.74997C13.9546 2.26976 14.606 2 15.2852 2C15.9644 2 16.6158 2.26976 17.0962 2.74997L17.25 2.90375C17.7302 3.3841 18 4.03559 18 4.7148C18 5.39401 17.7302 6.04542 17.25 6.52577L6.89621 16.8796C6.79699 16.9788 6.67268 17.0492 6.53655 17.0832L2.96198 17.9769C2.69815 18.0428 2.41907 17.9655 2.22677 17.7732C2.03448 17.5809 1.95718 17.3018 2.02313 17.038L2.91677 13.4635C2.95081 13.3273 3.02119 13.203 3.12041 13.1038L12.0566 4.16763L13.4742 2.74997ZM12.6043 5.80968L4.36692 14.047L3.83824 16.1618L5.95297 15.6331L14.1903 7.39573L12.6043 5.80968ZM15.2852 6.30085L13.6991 4.7148L14.5689 3.845C14.5689 3.84503 14.569 3.84498 14.5689 3.845C14.7589 3.65513 15.0166 3.54839 15.2852 3.54839C15.5538 3.54839 15.8115 3.65508 16.0015 3.845L16.155 3.99855C16.3449 4.18853 16.4516 4.44617 16.4516 4.7148C16.4516 4.9834 16.345 5.241 16.1551 5.43097C16.155 5.431 16.1551 5.43095 16.1551 5.43097L15.2852 6.30085Z"
                        fill="black"
                    />
                </svg>
            </div>
            <div
                class="delete-icon"
                :class="{ disabled: !accountData.actions.can_delete }"
                @click="deleteAccount"
            >
                <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M8.4 5.2H11.6C11.6 4.77565 11.4314 4.36869 11.1314 4.06863C10.8313 3.76857 10.4243 3.6 10 3.6C9.57565 3.6 9.16869 3.76857 8.86863 4.06863C8.56857 4.36869 8.4 4.77565 8.4 5.2ZM6.8 5.2C6.8 4.35131 7.13714 3.53737 7.73726 2.93726C8.33737 2.33714 9.15131 2 10 2C10.8487 2 11.6626 2.33714 12.2627 2.93726C12.8629 3.53737 13.2 4.35131 13.2 5.2H17.2C17.4122 5.2 17.6157 5.28429 17.7657 5.43431C17.9157 5.58434 18 5.78783 18 6C18 6.21217 17.9157 6.41566 17.7657 6.56569C17.6157 6.71571 17.4122 6.8 17.2 6.8H16.4944L15.7856 15.072C15.7175 15.8708 15.352 16.6149 14.7615 17.1571C14.171 17.6993 13.3985 18.0001 12.5968 18H7.4032C6.60153 18.0001 5.82902 17.6993 5.23852 17.1571C4.64802 16.6149 4.28254 15.8708 4.2144 15.072L3.5056 6.8H2.8C2.58783 6.8 2.38434 6.71571 2.23431 6.56569C2.08429 6.41566 2 6.21217 2 6C2 5.78783 2.08429 5.58434 2.23431 5.43431C2.38434 5.28429 2.58783 5.2 2.8 5.2H6.8ZM12.4 10C12.4 9.78783 12.3157 9.58434 12.1657 9.43431C12.0157 9.28429 11.8122 9.2 11.6 9.2C11.3878 9.2 11.1843 9.28429 11.0343 9.43431C10.8843 9.58434 10.8 9.78783 10.8 10V13.2C10.8 13.4122 10.8843 13.6157 11.0343 13.7657C11.1843 13.9157 11.3878 14 11.6 14C11.8122 14 12.0157 13.9157 12.1657 13.7657C12.3157 13.6157 12.4 13.4122 12.4 13.2V10ZM8.4 9.2C8.61217 9.2 8.81566 9.28429 8.96569 9.43431C9.11571 9.58434 9.2 9.78783 9.2 10V13.2C9.2 13.4122 9.11571 13.6157 8.96569 13.7657C8.81566 13.9157 8.61217 14 8.4 14C8.18783 14 7.98434 13.9157 7.83431 13.7657C7.68429 13.6157 7.6 13.4122 7.6 13.2V10C7.6 9.78783 7.68429 9.58434 7.83431 9.43431C7.98434 9.28429 8.18783 9.2 8.4 9.2ZM5.808 14.936C5.84208 15.3355 6.02493 15.7077 6.32035 15.9788C6.61577 16.2499 7.00223 16.4002 7.4032 16.4H12.5968C12.9975 16.3998 13.3836 16.2494 13.6786 15.9783C13.9737 15.7072 14.1563 15.3352 14.1904 14.936L14.888 6.8H5.112L5.808 14.936Z"
                        fill="black"
                    />
                </svg>
            </div>
        </template>

        <template v-if="selectable">
            <div class="account-status" @click.prevent.stop="selectAccount">
                <img
                    v-if="accountData.status === 'full'"
                    src="@/assets/images/full-selected-icon.svg"
                    alt=""
                />
                <img
                    v-if="accountData.status === 'empty'"
                    src="@/assets/images/none-selected-icon.svg"
                    alt=""
                />
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: 'AccountItem',
    props: {
        editable: {
            type: Boolean,
            default: false
        },
        selectable: {
            type: Boolean,
            default: false
        },
        showBalance: {
            type: Boolean,
            default: false
        },
        accountData: {
            type: Object,
            required: true
        }
    },
    emits: ['select-account', 'edit-account', 'delete-account'],
    methods: {
        selectAccount() {
            this.$emit('select-account')
        },

        editAccount() {
            this.$emit('edit-account')
        },

        deleteAccount() {
            this.$emit('delete-account')
        }
    }
}
</script>

<style scoped lang="scss">
.account-item {
    display: flex;
    align-items: center;
    padding: 0.75rem 1rem;
    background: $white;
    margin-bottom: 0.5rem;
    border-radius: 0.5rem;

    .account-link {
        display: flex;
        align-items: center;
        margin-right: auto;
        text-decoration: none;
        color: $black;

        //&:hover {
        //    cursor: pointer;
        //    color: $primary;
        //
        //    .group-icon {
        //        svg {
        //            path {
        //                stroke: $primary;
        //            }
        //        }
        //    }
        //}
    }

    .account-icon {
        width: 1.25rem;
        height: 1.25rem;
        margin-right: 0.5rem;
    }

    .account-name {
        margin-right: auto;
    }

    .account-balance {
        margin-right: 0.625rem;
        white-space: nowrap;
    }

    .edit-icon,
    .delete-icon {
        width: 1.25rem;
        height: 1.25rem;
        margin-left: 0.625rem;

        &:hover {
            cursor: pointer;

            svg {
                path {
                    fill: $primary;
                }
            }
        }

        &.disabled {
            pointer-events: none;

            svg {
                path {
                    fill: $grey;
                }
            }
        }
    }

    .account-status {
        display: flex;
        cursor: pointer;

        img {
            width: 1rem;
            height: 1rem;
        }
    }
}
</style>
